var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalEllipsis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41797 2.8125C2.12891 2.8125 2.73047 2.23828 2.73047 1.5C2.73047 0.789062 2.12891 0.1875 1.41797 0.1875C0.679688 0.1875 0.105469 0.789062 0.105469 1.5C0.105469 2.23828 0.679688 2.8125 1.41797 2.8125ZM1.41797 10.6875C0.679688 10.6875 0.105469 11.2891 0.105469 12C0.105469 12.7383 0.679688 13.3125 1.41797 13.3125C2.12891 13.3125 2.73047 12.7383 2.73047 12C2.73047 11.2891 2.12891 10.6875 1.41797 10.6875ZM1.41797 5.4375C0.679688 5.4375 0.105469 6.03906 0.105469 6.75C0.105469 7.48828 0.679688 8.0625 1.41797 8.0625C2.12891 8.0625 2.73047 7.48828 2.73047 6.75C2.73047 6.03906 2.12891 5.4375 1.41797 5.4375Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalEllipsis);
export default __webpack_public_path__ + "static/media/vertical-ellipsis.7ae7c77f74f80bdaaf95d7c9d94474b0.svg";
export { ForwardRef as ReactComponent };